var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CenterOnParent", { staticClass: "vh-100 m-0" }, [
    _c(
      "div",
      {
        staticClass: "card",
        staticStyle: { "max-width": "1280px", width: "90%" }
      },
      [
        _c("div", { staticClass: "card-body text-center" }, [
          _c("h2", { staticClass: "mb-4 text-secondary" }, [
            _vm._v(_vm._s(_vm.$t("visitorManagement.checkedInOut.title")))
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "mx-auto mb-3",
            attrs: { id: _vm.readerElementId }
          }),
          _vm._v(" "),
          _c("div", [
            !_vm.scanning
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg",
                    on: { click: _vm.startScanner }
                  },
                  [
                    _c("i", { staticClass: "bi bi-camera" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("visitorManagement.checkedInOut.startScan")
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    on: { click: _vm.stopScanner }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("visitorManagement.checkedInOut.stopScan")
                        ) +
                        "\n        "
                    )
                  ]
                )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }